import React, { useState } from "react";
import './HealthInsurance.css';
import SideNavBar from "../../Components/SideBar/Sidebar";
import Navbar from "../../Components/Support/Header";
import { Button, Layout, Select, Spin } from "antd";
import HRSourceFile from "../../Components/HRSourceFile/HRSourceFile";
import PayrollDeduction from "../../Components/PayrollDeduction/PayrollDeduction";
const { Header, Content } = Layout;

const HealthInsurance = () => {
    const [hrSelectorButton, setHRSelectorButton] = useState(true)
    const [deductionSelectorButton, setDeductionSelector] = useState(false)
    const setHR = () => {
        setHRSelectorButton(true)
        setDeductionSelector(false)
    }
    const setDeduction = () => {
        setDeductionSelector(true)
        setHRSelectorButton(false)
    }
    return (<>
        <Layout style={{ backgroundColor: "white", overflow: "hidden", height: "100vh", display: "flex" }} className="HIlayout-class">
            <SideNavBar />
            <Layout style={{ backgroundColor: "white", overflow: "hidden" }}>
                <Header className="hi-header">
                    <Navbar />
                </Header>
                <Content className="hi-content-class">
                    <div className="hr-deduction-division">
                        <div className="hr-active" onClick={setHR}>Health Insurance</div>
                        {/* <div className={deductionSelectorButton ? "hr-active" : "deduction-class"} onClick={setDeduction}>Payroll Deduction Report</div> */}
                    </div>
                    <div className="hr-deduction-class">
                        {hrSelectorButton ? <HRSourceFile /> : <PayrollDeduction />}
                    </div>
                </Content>
            </Layout>
        </Layout>
    </>)

}
export default HealthInsurance;